import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { SyncProvider } from '@/offline'
import { PhoneSessionProvider } from '@/auth/pin/PhoneSessionProvider'

/** Everything under /m: the sync engine runs and the PIN session exists. */
export function PhoneRoot() {
  // The phone app wears the alignment map's theme (tokens.css, index.css).
  useEffect(() => {
    const html = document.documentElement
    html.dataset.surface = 'phone'
    return () => {
      delete html.dataset.surface
    }
  }, [])
  return (
    <SyncProvider>
      <PhoneSessionProvider>
        <Outlet />
      </PhoneSessionProvider>
    </SyncProvider>
  )
}
